import { Icon } from "@abb/arcadia-ui-react"

export function getDoneIcon() {
  return <Icon iconName="icon_abb_dias icon-abb_completed-check" size={24} />
}

export function getEmptyIcon() {
  return <></>
}

export const booleanComparator = (a: string, b: string): number => {
  if (a === b) {
    return 0
  }
  return a === "true" ? 1 : -1
}
